import { z } from 'zod';
/**
 * One question asked of four tables: "where is the thing I am thinking of".
 *
 * A person with a campaign in mind knows its name, not which screen lists it.
 * `kind` is what the shell turns into a route, so adding a searchable thing
 * means adding a case there rather than sending a URL over the wire — a server
 * that named client routes would be a server that breaks when one is renamed.
 */
export const searchHitSchema = z.object({
    kind: z.enum(['contact', 'campaign', 'segment', 'template']),
    id: z.string(),
    label: z.string(),
    /** What tells two similarly named things apart. Empty when there is nothing. */
    detail: z.string(),
});
export const searchResultsSchema = z.object({ hits: z.array(searchHitSchema) });
//# sourceMappingURL=search.js.map